module.exports = __webpack_public_path__ + "static/media/identity-linvitation-card.d2423a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-linvitation-card.png
// module id = 248
// module chunks = 0